import React, { useEffect, useState } from 'react'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import { localisationMaster } from 'Localisation/Localisation'
import st from './StudyPrograms.module.scss'
import { Programm } from './Programm/Programm'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import AddProgrammModal from './AddProgrammModal/AddProgrammModal'
import Pagination from 'components/UI/Pagination/Pagination'
import { observer } from 'mobx-react'
import swal from 'sweetalert'
import Loader from 'components/UI/Loader/Loader'

const initPagination = {
  page: 1,
  limit: 10,
}

const StudyPrograms = () => {
  const [studyProgram, setStudyProgram] = useState(null)
  const [pagination, setPagination] = useState(initPagination)
  const [loading, setLoading] = useState(false)

  const fetchProgram = () => {
    superAxiosRequest({
      method: 'get',
      link: 'db/programtypes',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setStudyProgram(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchProgram()
    setLoading(true)
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data.company }),
    }
  }

  const addProgram = () => {
    const ms = {
      modalBodyComponent: () => <AddProgrammModal />,
      button: 'Save',
      link: 'db/programtypes',
      title: 'Add training program',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchProgram()
      },
      valid: {
        name: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const editProgram = (data) => {
    const ms = {
      modalBodyComponent: () => <AddProgrammModal />,
      button: 'Save',
      link: `db/programtypes/${data?.id}`,
      title: 'Edit training program',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setStudyProgram((prev) => {
          return {
            ...prev,
            result: prev.result.map((program) =>
              program.id === data.id ? { ...program, ...data } : program,
            ),
          }
        })
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteProgram = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the program?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `db/programtypes/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setStudyProgram((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editProgram(items)],
      ['delete', () => deleteProgram(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={localisationMaster('title', 'company/programs')}>
          <HeaderAddButton title={'Добавить программу'} onClick={addProgram} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Entries: {studyProgram?._meta?.count_items}
          </div>
          <div>
            {studyProgram?.result?.map((program, index) => (
              <Programm
                key={program.id}
                program={program}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {studyProgram?._meta?.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={studyProgram._meta?.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default observer(StudyPrograms)
